import Link from 'next/link';
import ModalWrapper from './GroupModal';
import { useState } from 'react';
import CheckoutForm from './CheckoutForm';
import NextImage from '@/features/Image';
import { useAuth } from '@/features/authentication/hooks/auth';
import { usePathname, useRouter } from 'next/navigation';
export default function GroupShoppingProductCard({
  product,
  index,
  address,
}: any) {
  const { user } = useAuth({ redirectIfAuthenticated: 'goBack' });
  const router = useRouter();
  const [show, setShow] = useState(false);
  const pathName = usePathname();
  const handleClose = () => setShow(false);

  const handleShow = () => {
    if (!user) return router.push(`/login?redirect=${pathName}`);
    setShow(true);
  };

  return (
    <>
      <div className="group-default inner-quickview inner-icon">
        <figure>
          <Link href={`/product/${product.slug}`}>
            {product.large_pictures?.length > 0 ? (
              <NextImage
                src={product.large_pictures[0].url}
                alt="Product image"
                width={product.large_pictures[0].width}
                height={product.large_pictures[0].height}
                className={`group-img ${index === 1 ? 'last-image' : ''}`}
                style={{ aspectRatio: '1/1' }}
              />
            ) : (
              <NextImage
                src="/images/product_empty_image.png"
                alt="Product image"
                width={300}
                height={300}
                style={{ aspectRatio: '1/1' }}
              />
            )}
          </Link>
          <span
            onClick={handleShow}
            className="trk-btn trk-btn--secondary remove-position p-absolute rounded-0 w-full"
          >
            CREATE NEW GROUP
          </span>
        </figure>
        <div className="product-details">
          <div className="title-wrap">
            <h6 className="product-title short-text fw-medium">
              <Link href={`/product/${product.slug}`}>{product.name}</Link>
            </h6>
          </div>
          {product.price && (
            <div className="price-box">
              <span className="old-price">
                <del>৳{product.price}</del>
              </span>
              <span className="product-price">
                ৳{product.group_purchase_price}
              </span>
            </div>
          )}
        </div>
        <div className="product-details-footer">
          <p>
            Duration:{' '}
            <span className="text-danger">{product.group_duration} days</span>
          </p>
        </div>
      </div>
      <ModalWrapper show={show} handleClose={handleClose} title="Create group">
        <CheckoutForm address={address} product={product} />
      </ModalWrapper>
    </>
  );
}
